import MkuCheckbox from './src/checkbox';

MkuCheckbox.install = function (Vue) {
  Vue.component(MkuCheckbox.name, MkuCheckbox);
};

export default MkuCheckbox;
